import React from "react";
import RequestEngine from "../../core/RequestEngine";
import strings from "../../core/translate";
import { apiErrorMessage } from "../../shared/api-error";
import {
  FormSection,
  FormGrid,
  TextField,
  FormAlert,
  FormActions,
} from "../../components/Form/FormKit";

// One line of a garage service price list.
export default class ServiceDetailForm extends React.Component {
  constructor(props) {
    super(props);
    const item = props.item || {};
    this.state = {
      id: item.id || "",
      version: item.version,
      name: item.name || "",
      price: item.price === null || item.price === undefined ? "" : item.price,
      remark: item.remark || "",
      loading: false,
      error: "",
      errors: {},
    };
    this.engine = new RequestEngine();
  }

  validate() {
    const { name, price } = this.state;
    const errors = {};

    if (`${name}`.trim().length < 2) {
      errors.name = strings.name_min_hint;
    }
    if (`${price}`.trim() !== "" && Number(price) < 0) {
      errors.price = strings.price_min_hint;
    }
    return errors;
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const { id, version, name, price, remark } = this.state;
    this.setState({ loading: true, error: "", errors: {} });

    const { branchId, serviceId } = this.props;
    const pathname = `merchants-branches/${branchId}/services/${serviceId}/details`;
    const payload = {
      name: `${name}`.trim(),
      price: `${price}`.trim() === "" ? undefined : Number(price),
      remark: `${remark}`.trim() || undefined,
    };

    try {
      const response = id
        ? await this.engine.updateItem(pathname, id, { ...payload, version })
        : await this.engine.saveItem(pathname, payload);

      if (response && (response.status === 200 || response.status === 201)) {
        this.setState({ loading: false });
        this.props.onSaved(response.data);
        return;
      }
    } catch (err) {
      this.setState({ error: apiErrorMessage(err) });
    }
    this.setState({ loading: false });
  };

  render() {
    const { name, price, remark, loading, error, errors } = this.state;

    return (
      <form className="mform" onSubmit={this.handleSubmit}>
        <FormSection
          title={strings.branch_service_details}
          icon="nc-icon nc-bullet-list-67"
        >
          <FormGrid>
            <TextField
              label={strings.name}
              required
              value={name}
              onChange={(value) => this.setState({ name: value })}
              error={errors.name}
            />
            <TextField
              label={strings.price}
              type="number"
              min="0"
              step="any"
              value={price}
              onChange={(value) => this.setState({ price: value })}
              error={errors.price}
            />
          </FormGrid>
          <FormGrid full>
            <TextField
              label={strings.remark}
              type="textarea"
              value={remark}
              onChange={(value) => this.setState({ remark: value })}
            />
          </FormGrid>
        </FormSection>

        <FormAlert>{error}</FormAlert>
        <FormActions onCancel={this.props.onCancel} loading={loading} />
      </form>
    );
  }
}
